import { useMutation } from '@tanstack/react-query';

import { orderServices } from '@hero/services';

export const useSendGiftCardEmail = (options = {}) => {
  return useMutation(code => orderServices.sendGiftCardEmail(code), options);
};
